var d = /* @__PURE__ */ ((r) => (r.Light = "manifold-scheme-light", r.Dark = "manifold-scheme-dark", r))(d || {}), i = /* @__PURE__ */ ((r) => (r[r.Image = 0] = "Image", r[r.GIF = 1] = "GIF", r[r.Video = 2] = "Video", r[r.Audio = 3] = "Audio", r[r.Model = 4] = "Model", r[r.Other = 5] = "Other", r))(i || {});
export {
  i as ContentType,
  d as ManifoldSchemeClass
};
